import { Add as AddIcon } from "@mui/icons-material";
import StyledFabFixed from "components/StyledFabFixed";
import technicianSettings from "helpers/technicianSettings";
import { CreateJobDialog } from "pages/jobs/dialogs/CreateJobDialog";
import { FC } from "react";
import { useAppDispatch, useAppSelector } from "store";
import { selectConnectionStatus } from "store/root.store";
import {
  selectCreateJobOpen,
  setOpen as setOpenCreateJobDialog,
} from "store/slices/dialogs/createJob.store";

export const JobListActions: FC = (props) => {
  const dispatch = useAppDispatch();
  const isOnline = useAppSelector(selectConnectionStatus);
  const openCreateJobDialog = useAppSelector(selectCreateJobOpen);
  const canCreateJob = technicianSettings.canCreateJob && isOnline;

  return (
    <>
      {canCreateJob && !openCreateJobDialog && (
        <StyledFabFixed
          color="primary"
          component="span"
          data-testid="createJobButton"
          onClick={() => dispatch(setOpenCreateJobDialog({ open: true }))}
        >
          <AddIcon />
        </StyledFabFixed>
      )}
      {canCreateJob && openCreateJobDialog && <CreateJobDialog />}
    </>
  );
};
